import { InfoRounded, PeopleRounded } from "@mui/icons-material";
import { Box, CircularProgress, Typography } from "@mui/material";
import List from "@mui/material/List";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateCurrentConnectTop } from "../../redux/CurrentConnect";
import AlertGeneral from "../alerts/AlertGeneral";
import FriendRequest from "./layouts/FriendRequest";

export default function RequestContainer({ isLoadingPostLaunch }) {
  const { connectTop } = useSelector((state) => state.currentConnectRequest);
  const [isFetching, setIsFetching] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [openAlertGeneral, setOpenAlertGeneral] = useState(false)

  const { user } = useSelector((state) => state.currentUser);

  // tackle corner cases screen width
  const screenWidth = window.screen.availWidth;
  // dispatch action
  const dispatch = useDispatch();

  // extracting current userId for locating users ain't friend with
  const { _id } = user || {};


  // fetch from the backend the top 3 users
  useEffect(() => {
    // if already available in redux don't fetch
    if (connectTop) {
      return;
    }

    // set is fetching to true
    setIsFetching(true);

    // performing get request
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_BASE_ROUTE}/connections/connection/users/${_id}`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        // update the redux of connect request suggestion
        if (res?.data) {
          dispatch(updateCurrentConnectTop(res.data));
        }
      })
      .catch(async (err) => {
        console.log(err);

        if (err?.code === "ERR_NETWORK") {
          setErrorMessage(
            "Server is unreachable check your internet connection"
          );
          return;
        }
        setErrorMessage(err?.response?.data || "Unable to load network suggestions.");
        setOpenAlertGeneral(true)
      })
      .finally(() => {
        // set is fetching to false
        setIsFetching(false);
      });
  }, [dispatch, _id, connectTop]);

  // get the rightbar expanded appropriately
  const rightBarExpanded = () => {
    if (screenWidth > 1300) {
      return 360;
    }

    if (screenWidth > 1250) {
      return 350;
    }

    if (screenWidth > 1400) {
      return 380;
    }
    return;
  };

  return (
    <React.Fragment>
      <Box alignItems={"center"} display={"flex"} justifyContent={"center"}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          px={1}
          py={1.5}
        >
          <Box display="flex" alignItems="center" gap={1}>
            <PeopleRounded sx={{ color: "#D6B25E", fontSize: 18 }} />
            <Typography fontSize={13} fontWeight={600} color="#FFFDF7">
              Network Suggestions
            </Typography>
          </Box>

          {isFetching && <CircularProgress size={14} />}
        </Box>
      </Box>
      <List
        className="rounded"
        sx={{
          background: "rgba(255,255,255,0.03)",
          border: "1px solid rgba(255,255,255,0.08)",
          borderRadius: "12px",
          backdropFilter: "blur(10px)",
          width: "100%",
          p: 0,
        }}
      >
        <Box>
          {connectTop?.slice(0, 3).map((connection, index) => (
            <Box key={index}>
              <FriendRequest
                isLoadingRequest={isFetching}
                connect_request={connection}
              />
            </Box>
          ))}
        </Box>
      </List>

      {/* alert general of the error message */}
      {errorMessage && (
        <AlertGeneral
          title={'something went wrong!'}
          message={errorMessage}
          isError={true}
          openAlertGeneral={openAlertGeneral}
          setOpenAlertGeneral={setOpenAlertGeneral}
          setErrorMessage={setErrorMessage}
          defaultIcon={<InfoRounded />}
        />
      )}

    </React.Fragment>
  );
}
